export default {
    alert: {
        ok: '确定'
    },

    confirm: {
        ok: '确定',
        cancel: '取消'
    },

    prompt: {
        ok: '确定',
        cancel: '取消',
        placeHolder: '请输入'
    },

    popupPicker: {
        ok: '确定',
        cancel: '取消'
    }
};


// WEBPACK FOOTER //
// ./src/locale/lang/zh-CN.js